function boolEnv(key: string, fallback: boolean): boolean {
  const val = import.meta.env[key]
  if (val === undefined || val === '') return fallback
  return val === 'true'
}

export const MODULES = {
  communication: true,
  crm: boolEnv('VITE_MODULE_CRM', false),
  automation: boolEnv('VITE_MODULE_AUTOMATION', false),
  ai: boolEnv('VITE_MODULE_AI', false),
} as const

export type ModuleName = keyof typeof MODULES

export function isModuleEnabled(name: ModuleName): boolean {
  return MODULES[name]
}

// Global toggle for the "ReportBadge" feedback buttons.
// Hidden by default; set VITE_REPORT_BADGE=true to show.
export const REPORT_BADGE_ENABLED = boolEnv('VITE_REPORT_BADGE', false)
